import {Component, OnInit} from '@angular/core';
import {Shop} from '../../models/shop';
import {ShopService} from '../../services/shop.service';
import {ModalController} from '@ionic/angular';
import * as moment from 'moment';
import {WorkingPeriod} from "../../models/submodels/timetable";

@Component({
  selector: 'app-working-periods',
  templateUrl: './working-periods.component.html',
  styleUrls: ['./working-periods.component.scss'],
})
export class WorkingPeriodsComponent implements OnInit {

  shop: Shop = new Shop();
  dayLabels  = {
    monday: 'Segunda-Feira',
    tuesday: 'Terça-Feira',
    wednesday: 'Quarta-Feira',
    thursday: 'Quinta-Feira',
    friday: 'Sexta-Feira',
    saturday: 'Sábado',
    sunday: 'Domingo',
  };
  dayLabelKeys = Object.keys(this.dayLabels);
  addingStartTime;
  addingEndTime;

  constructor(private shopService: ShopService, private modalController: ModalController) { }

  ngOnInit() {
    this.shopService.getCurrentShop().subscribe(shop => {
      this.shop = shop;
      console.log(shop.timetable);
    });
  }

  dismiss() {
    this.modalController.dismiss();
  }

  deletePeriod(day: string, position: number) {
    this.shop.timetable[day].workingPeriods.splice(position, 1);
    this.save();
  }

  setAddingStartTime(e) {
    this.addingStartTime = moment(e.target.value).format('HH:mm');
  }

  setAddingEndTime(e) {
    this.addingEndTime = moment(e.target.value).format('HH:mm');
  }

  addPeriod(day: string) {
    console.log(this.addingStartTime);
    console.log(this.addingEndTime);
    if (this.addingStartTime && this.addingEndTime) {
      this.shop.timetable[day].workingPeriods.push(new WorkingPeriod(this.addingStartTime, this.addingEndTime));
      this.save();
    } else {
      alert('Preencher Início e Fim');
    }
  }

  save() {
    this.dayLabelKeys.forEach(day => {
      if (this.shop.timetable[day].workingPeriods.length) {
        this.shop.timetable[day].isClosed = false;
      } else {
        this.shop.timetable[day].isClosed = true;
      }
    });
    this.shopService.updateShop(this.shop);
  }
}
